import { ChangeDetectionStrategy, booleanAttribute, Component, inject, input } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { IAlertComponent, IButtonDirective } from "@front/m19-ui";
import { AmazonInvoicesService } from "./amazon-invoices.service";
import { TranslocoDirective } from "@jsverse/transloco";
import { RouterLink } from "@angular/router";

@Component({
  selector: "app-overdue-amazon-invoice-warning",
  imports: [IAlertComponent, TranslocoDirective, RouterLink, IButtonDirective],
  template: `<ng-container *transloco="let t">
    @if (overdueInvoices() && overdueInvoices()!.length > 0) {
      <IAlert class="m-4" type="error" [title]="t('amazon-invoices.you_have_overdue_amazon_invoices')">
        <p>{{ t("amazon-invoices.warning_overdue") }}</p>
        <p>{{ t("amazon-invoices.payment_notice") }}</p>
        @if (withLinkToInvoicePage()) {
          <a iButton variant="destructive" class="mt-2" routerLink="/amazon-invoices">
            {{ t("amazon-invoices.view_invoices") }}
          </a>
        }
      </IAlert>
    }
  </ng-container> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverdueAmazonInvoiceWarningComponent {
  private readonly amazonInvoicesService = inject(AmazonInvoicesService);

  public readonly withLinkToInvoicePage = input(false, { transform: booleanAttribute });

  readonly overdueInvoices = toSignal(this.amazonInvoicesService.overdueInvoices);
}
